import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryCards from './components/CategoryCards';
import LatestComics from './components/LatestComics';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StructuredData from '@/components/feature/StructuredData';

const homeStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '奶水漫画',
      url: 'https://www.naishuimanhua.com',
      description: '精选母婴哺乳主题原创漫画合集，以温馨幽默的画风呈现新手妈妈哺乳日常、母乳喂养知识与亲子互动故事',
      sameAs: ['https://weibo.com/naishuimanhua', 'https://www.xiaohongshu.com/user/naishuimanhua'],
    },
    {
      '@type': 'WebSite',
      name: '奶水漫画',
      url: 'https://www.naishuimanhua.com',
      description: '奶水漫画 - 精选母婴哺乳主题漫画合集，汇聚哺乳日常、母乳喂养知识、亲子互动等原创漫画内容',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.naishuimanhua.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '奶水漫画 - 精选母婴哺乳主题漫画合集',
      description: '奶水漫画专题页，汇聚母婴哺乳主题原创与精选漫画内容，以温馨幽默的画风呈现新手妈妈哺乳日常、母乳喂养知识与亲子互动故事',
      isPartOf: { '@type': 'WebSite', name: '奶水漫画' },
      about: { '@type': 'Thing', name: '母乳喂养漫画' },
    },
  ],
};

export default function Home() {
  return (
    <>
      <StructuredData data={homeStructuredData} />
      <main>
        <HeroSection />
        <FeaturedComics />
        <CategoryCards />
        <LatestComics />
        <CTASection />
        <FAQSection />
      </main>
    </>
  );
}